import { render, staticRenderFns } from "./workflowSet.vue?vue&type=template&id=cd490556&scoped=true"
import script from "./workflowSet.vue?vue&type=script&lang=js"
export * from "./workflowSet.vue?vue&type=script&lang=js"
import style0 from "./workflowSet.vue?vue&type=style&index=0&id=cd490556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd490556",
  null
  
)

export default component.exports